// extracted by mini-css-extract-plugin
export default {"custom":"Custom_custom__Ldv8L","custom__topGradient":"Custom_custom__topGradient__Zofkx","custom__cardMain":"Custom_custom__cardMain__ILTax"};